import Vue from 'vue';
import requireSubscription from './directives/v-require-subscription';

Vue.directive('focus', {
  // When the bound element is inserted into the DOM
  inserted: function (el) {
    // Focus the element
    el.focus();

    // If element can not be focused then focus its first focusable child
    if (el !== document.activeElement) {
      el.querySelector('input').focus();
    }
  },
});

Vue.directive('require-subscription', requireSubscription);
